import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {BsArrowRight, BsArrowLeft} from "react-icons/bs"
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const WhatPeopleSay = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: <span><BsArrowRight /></span>,
        prevArrow: <span><BsArrowLeft /></span>,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ],
          beforeChange: (current, next) => {
            document
              .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
              .forEach(el => el.setAttribute('tabindex', '-1'));
          },
          afterChange: () => {
            document
              .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
              .forEach(el => el.removeAttribute('tabindex'));
          }
    };
    return (
        <div className='testimo-jewelry2 parallax'>
            <Container>
                <Row>
                    <Col md={12} className='wht_hd '>
                        <h2 className="title24 white text-center m-0">What People Say</h2>					
                    </Col>

                    <Col>
                        <div className='testimo-slider2'>
                            <div className="testimonial-icon1">
                                <i className="fa fa-quote-left"></i>
                            </div>
                            <Slider {...settings}>
                                <div className="item-testimo2 text-center">
                                    <p className="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" className="review_read_more">Read more...</a></p>
                                    <ul className="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 className="title18"><a href="#" className="txt-black">Lorem Ipsum</a></h3>

                                    <div className="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="item-testimo2 text-center">
                                    <p className="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" className="review_read_more">Read more...</a></p>
                                    <ul className="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 className="title18"><a href="#" className="txt-black">Lorem Ipsum</a></h3>

                                    <div className="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/yelp-reviews.jpg`} alt="img" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="item-testimo2 text-center">
                                    <p className="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" className="review_read_more">Read more...</a></p>
                                    <ul className="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 className="title18"><a href="#" className="txt-black">Lorem Ipsum</a></h3>

                                    <div className="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="item-testimo2 text-center">
                                    <p className="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" className="review_read_more">Read more...</a></p>
                                    <ul className="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 className="title18"><a href="#" className="txt-black">Lorem Ipsum</a></h3>

                                    <div className="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="item-testimo2 text-center">
                                    <p className="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" className="review_read_more">Read more...</a></p>
                                    <ul className="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 className="title18"><a href="#" className="txt-black">Lorem Ipsum</a></h3>

                                    <div className="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/yelp-reviews.jpg`} alt="img" className="img-responsive" />
                                    </div>
                                </div>
                                <div className="item-testimo2 text-center">
                                    <p className="desc ">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever <a href="#" target="_blank" className="review_read_more">Read more...</a></p>
                                    <ul className="reviews_icon">
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                        <li> <LazyLoadImage src={`${ImageUrl}theme/tokyo/str-b.svg`} alt='' /> </li>
                                    </ul>
                                    <h3 className="title18"><a href="#" className="txt-black">Lorem Ipsum</a></h3>

                                    <div className="reviewimg_p">
                                        <LazyLoadImage src={`${ImageUrl}theme/tokyo/ivouch-reviews.jpg`} alt="img" className="img-responsive" />
                                    </div>
                                </div>
                            </Slider>
                        </div>
                        
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default WhatPeopleSay